export default __webpack_public_path__ + "media/images/app-icon-e5bdb8d5e39f1933d612a310d421b191.svg";